import React from 'react'
import clsx from 'clsx'
import { makeStyles } from '@mui/styles'
import { priceKinds } from '@/modules/base/util/constants'

export const PriceKindSwitch = (props) => {
  const classes = useStyles(props)
  const {
    priceKind = priceKinds.GROSS,
    disabled = false,
    onChangePriceKind,
  } = props

  return (
    <div className={classes.container}>
      <div className={clsx(classes.priceKindWrapper, priceKind === priceKinds.GROSS && classes.active)} onClick={() => !disabled && onChangePriceKind(priceKinds.GROSS)}>
        <span className={clsx(classes.label, priceKind === priceKinds.GROSS && classes.activeLabel)}>Brutto</span>
      </div>
      <div className={clsx(classes.priceKindWrapper, priceKind === priceKinds.NET && classes.active)} onClick={() => !disabled && onChangePriceKind(priceKinds.NET)}>
        <span className={clsx(classes.label, priceKind === priceKinds.NET && classes.activeLabel)}>Netto</span>
      </div>
    </div>
  )
}

const useStyles = makeStyles(theme => ({
  priceKindWrapper: {
    width: '100%',
    justifyContent: 'center',
    cursor: (props) => props.disabled ? 'default' : 'pointer',
    display: 'flex',
    padding: '3px 0px',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: `${theme.disabledBorderColor}`,
    background: theme.backgroundColor,
    '&:first-child': {
      borderTopLeftRadius: 4,
      borderBottomLeftRadius: 4,
      borderRightWidth: 0,
    },
    '&:last-child': {
      borderTopRightRadius: 4,
      borderBottomRightRadius: 4,
      borderLeftWidth: 0,
    },
    '&$active': {
      borderWidth: 1,
      background: theme.backgroundColorDisabled,
    },
    '&:hover, :hover *': {
      color: (props) => props.disabled ? null : theme.primary,
      borderColor: (props) => props.disabled ? null : theme.primary,
      background: (props) => props.disabled ? null : theme.backgroundColorDisabled,
      '&:before': {
        background: (props) => props.disabled ? null : theme.backgroundColor,
      },
    },
  },
  label: {
    fontSize: 12,
    fontWeight: 500,
    color: theme.disabledColor,
  },
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  active: {
    borderColor: theme.primary,
  },
  activeLabel: {
    color: theme.primary,
  },
}))

export default PriceKindSwitch
